import { Link as RouterLink } from "react-router";
import styled, { css } from "styled-components";

const LinkStyles = css`
  color: ${({ theme }) => theme.colors.secondaryThree};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Link = styled(RouterLink)`
  ${LinkStyles}
`;

export default Link;
